import styled from 'styled-components';

export const BlockContent = styled.div`
  h4,
  h3 {
    margin-bottom: 35px;
  }

  h4 {
    font-size: 18px;
    line-height: 22px;
    color: #000;
    font-weight: 400;

    &[dir='ltr'] {
      letter-spacing: 1.29px;
      font-family: 'LibreBaskervilleRegular';
    }

    &[dir='rtl'] {
      font-family: GEAwtarDWTCMedium, sans-serif;
    }

    @media (max-width: 767px) {
      font-size: 16px !important;
      line-height: normal !important;
    }
  }

  h3 {
    &[dir='rtl'] {
      font-family: GESSTwoDWTCMedium, sans-serif;
    }

    @media (max-width: 767px) {
      font-size: 18px !important;
      line-height: normal !important;
    }
  }

  p {
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 0;
    color: #898989;

    a {
      color: #898989;
    }
  }

  p + p {
    margin-top: 20px;
  }

  @media (max-width: 767px) {
    margin-bottom: 30px;
  }

  @media (max-width: 575px) {
    margin-bottom: 30px;
  }
`;

export const LineSeparator = styled.div`
  background: #1b7bdd;
  height: 1px;
  width: 80%;
  margin-bottom: 35px;
`;

export const UlList = styled.ul`
  margin: 0 0 20px;
  padding: 0;
  list-style: none;
`;

export const LiList = styled.li`
  position: relative;
  font-size: 14px;
  color: #898989;
  margin-bottom: 1.5rem;

  &[dir='ltr'] {
    padding-left: 40px;

    &:before {
      left: 0;
      transform: rotate(-45deg);
    }
  }

  &[dir='rtl'] {
    padding-right: 40px;
    &:before {
      right: 0;
      transform: rotate(135deg);
    }
  }

  strong {
    font-family: ${({ dir }) =>
      dir === 'rtl' ? "'GESSTwoDWTCMedium,sans-serif' " : 'DINMediumAlternate '};
  }

  &:before {
    content: '';
    position: absolute;
    top: 10px;
    font-size: 14px;
    color: #000;
    width: 10px;
    height: 10px;
    border: solid #000;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
  }
`;

export const BlockInnerContent = styled.p`
  padding-left: 40px;
  width: 100%;

  a {
    transition: 0.3s ease all;
    display: inline-block;
    color: #000 !important;
    &:hover {
      color: #1b7bdd;
    }
  }
`;
